import m from "../../es2015/lang/en_CA";
window.am4lang_en_CA = m;


//////////////////
// WEBPACK FOOTER
// ./lang/en_CA.js
// module id = null
// module chunks = 